// extracted by mini-css-extract-plugin
export default {"img":"SlideSection_img__kcbHh"};